/** A4 menu page dimensions and px scaling for the flip-book preview. */
export const MENU_PAGE_WIDTH_MM = 210
export const MENU_PAGE_HEIGHT_MM = 297
export const MENU_PAGE_ASPECT = MENU_PAGE_HEIGHT_MM / MENU_PAGE_WIDTH_MM

const MM_TO_PX = 96 / 25.4

const MENU_PAGE_WIDTH_PX = MENU_PAGE_WIDTH_MM * MM_TO_PX

export function menuPageScale(pageWidthPx: number): number {
  return pageWidthPx / MENU_PAGE_WIDTH_PX
}

export function computeFlipPageSize(viewport: { width: number; height: number }) {
  const padding = 32
  const toolbar = 128
  const controls = 88
  const maxHeight = viewport.height - toolbar - controls - padding * 2
  const maxSpreadWidth = Math.min(viewport.width - padding * 2, 1100)
  const pageWidth = Math.min(maxSpreadWidth / 2, maxHeight / MENU_PAGE_ASPECT)
  const pageHeight = pageWidth * MENU_PAGE_ASPECT

  return {
    width: Math.max(280, Math.floor(pageWidth)),
    height: Math.max(396, Math.floor(pageHeight)),
  }
}
